import { appURL } from 'config'
export default appURL
